//---
// Action types

// @todo Rename to ACTION_GROUP_*
const ACTION_LIST   = 'LIST';
const ACTION_CREATE = 'CREATE';
const ACTION_SHOW   = 'SHOW';
const ACTION_UPDATE = 'UPDATE';
const ACTION_DEL    = 'DEL';

// @todo Rename to ACTION_GROUPS
export const ACTIONS = {
  LIST:   ACTION_LIST,
  CREATE: ACTION_CREATE,
  SHOW:   ACTION_SHOW,
  UPDATE: ACTION_UPDATE,
  DEL:    ACTION_DEL,
};


//---
// Methods

const METHOD_GET   = 'GET';
const METHOD_POST  = 'POST';
const METHOD_PUT   = 'PUT';
const METHOD_PATCH = 'PATCH';
const METHOD_DEL   = 'DELETE';

export type SaveMethod = METHOD_POST | METHOD_PUT | METHOD_PATCH;

const METHODS = {
  GET:  METHOD_GET,
  POST: METHOD_POST,
  PUT:  METHOD_PUT,
  DEL:  METHOD_DEL,
};

const METHODS_BY_ACTION = {
  LIST:   {
    GET: METHOD_GET,
  },
  CREATE: {
    POST: METHOD_POST,
  },
  SHOW:   {
    GET: METHOD_GET,
  },
  UPDATE: {
    GET: METHOD_GET,
    PUT: METHOD_PUT,
  },
  DEL:    {
    DELETE: METHOD_DEL,
  },
};

const SAVE_METHODS_BY_ACTION_GROUP = {
  CREATE: METHOD_POST,
  UPDATE: METHOD_PUT,
  DEL:    METHOD_DEL,
};


export {
  METHODS,
  METHOD_GET,
  METHOD_POST,
  METHOD_PUT,
  METHOD_PATCH,
  METHOD_DEL,
  METHODS_BY_ACTION,
  SAVE_METHODS_BY_ACTION_GROUP
};


//---
// Stages

const STAGE_REQUEST = 'REQUEST';
const STAGE_SUCCESS = 'SUCCESS';
const STAGE_FAILURE = 'FAILURE';

const STAGES = {
  REQUEST: STAGE_REQUEST,
  SUCCESS: STAGE_SUCCESS,
  FAILURE: STAGE_FAILURE,
};


export { STAGES };


// WEBPACK FOOTER //
// ./src/actions/utils/apiResources/apiResourceActions.const.js